import BeautyPreferencesHeader from 'components/BeautyPreferencesRedesigned/Header/BeautyPreferencesHeader';

export default BeautyPreferencesHeader;
